import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getPlans} from '../../services/getPlans';

export const useGetPlans = () =>
	useQuery({
		queryKey: [QUERY_KEYS.PLANS, {excludeWalletCode: true}],
		queryFn: async ({signal}) => getPlans(signal),
	});
